export class FeatureFlags {
  public static readonly UW_NORA_EHR_LABPIQ_AUTO_ORDER_ENABLED =
    'uw_nora_ehr_labpiq_auto_order_enabled';
  public static readonly UW_NORA_HALT_CLR_ENABLED = 'uw_nora_halt_clr_enabled';
  public static readonly UW_NORA_DECISION_V2_ENABLED = 'uw_nora_decision_v2_enabled';
  public static readonly UW_NORA_RX_HISTORY_V2_ENABLED =
    'uw_nora_rx_history_v2_enabled';
  public static readonly UW_NORA_AGENCY_SEARCH_ENABLED =
    'uw_nora_agency_search_enabled';
  public static readonly UW_NORA_MIB_CODEBACK_DRAFT_ENABLED =
    'uw_nora_mib_codeback_draft_enabled';
}
